// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"158":"8fe96115","347":"3ff6166c"}[chunkId] + ".chunk.css";
};